import { useEffect, useRef } from "react";

/* Minimal CSS-transform ticker — content rendered exactly 2x (one screen + one
   duplicate for the seamless loop), GPU-only translateX, no JS per frame.
   Paused completely while off-screen so idle marquees never cost frames. */
export function Ticker({ children, duration = 30, pauseOnHover = false, testid }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return;
    const io = new IntersectionObserver(
      ([entry]) => { el.dataset.paused = entry.isIntersecting ? "0" : "1"; },
      { rootMargin: "120px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div className="zjz-ticker" data-testid={testid} data-pause-hover={pauseOnHover ? "1" : undefined} ref={ref}>
      <div className="zjz-ticker-track" style={{ animationDuration: `${duration}s` }}>
        <div className="zjz-ticker-group">{children}</div>
        <div className="zjz-ticker-group" aria-hidden="true">{children}</div>
      </div>
    </div>
  );
}
